module.exports = __webpack_public_path__ + "img/TimeManagement.e2cdeb6e.svg";